import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Plans from "../pages/Plans";
import Settings from "../pages/Settings";
import DashboardLayout from "../layout/DashboardLayout";
import AdminLayout from "../layout/AdminLayout";
import Sites from "../pages/Sites";
import Backups from "../pages/Backups";
import Analytics from "../pages/Analytics";
import Authentication from "../pages/Authentication";
import Users from "../pages/Users";
import SiteDetail from "../pages/SiteDetail";
import UserProfile from "../pages/UserProfile";
import AllActivities from "../pages/AllActivities";
import NotFound from "../pages/NotFound";
import AdminProtectedRoute from "../components/ProtectedRoute";
import Applications from "../pages/Applications";
import ApplicationDetail from "../pages/Applications/ApplicationDetail";
import Landing from "../pages/Landing";
import VerifyEmail from "../pages/VerifyEmail";
import OrgSettings from "../pages/OrgSettings";
import InviteAccept from "../pages/InviteAccept";
import Billing from "../pages/Billing";
import Usage from "../pages/Usage";
import ImportSite from "../pages/ImportSite";

// Admin pages
import AdminDashboard from "../pages/admin/AdminDashboard";
import AdminUsers from "../pages/admin/AdminUsers";
import AdminSites from "../pages/admin/AdminSites";
import AdminWorkers from "../pages/admin/AdminWorkers";
import AdminContainers from "../pages/admin/AdminContainers";
import AdminApplications from "../pages/admin/AdminApplications";
import AdminPlans from "../pages/admin/AdminPlans";
import AdminBackups from "../pages/admin/AdminBackups";
import AdminActivities from "../pages/admin/AdminActivities";
import AdminSettings from "../pages/admin/AdminSettings";

const AuthProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/auth" />;
};

export default function AppRoutes() {
  return (
    <BrowserRouter>
      {/* <Navbar /> */}
      <Routes>
        {/* Public Landing Page */}
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Authentication />} />
        <Route path="/auth/verify-email" element={<VerifyEmail />} />

        {/* Public Invitation Page */}
        <Route path="/invite/:token" element={<InviteAccept />} />

        {/* Protected Dashboard Routes */}
        <Route
          path="/dashboard/*"
          element={
            <AuthProtectedRoute>
              <DashboardLayout />
            </AuthProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="sites" element={<Sites />} />
          <Route path="sites/:id" element={<SiteDetail />} />
          <Route path="applications" element={<Applications />} />
          <Route path="applications/:id" element={<ApplicationDetail />} />
          <Route path="backups" element={<Backups />} />
          {/* <Route path="files" element={<FileManager />} /> */}
          <Route path="analytics" element={<Analytics />} />
          <Route
            path="users"
            element={
              <AdminProtectedRoute requireAdmin>
                <Users />
              </AdminProtectedRoute>
            }
          />
          <Route path="plans" element={<Plans />} />
          <Route path="settings" element={<Settings />} />
          <Route path="billing" element={<Billing />} />
          <Route path="usage" element={<Usage />} />
          <Route path="org/settings" element={<OrgSettings />} />
          <Route path="profile" element={<UserProfile />} />
          <Route path="activities" element={<AllActivities />} />
          <Route path="import-site" element={<ImportSite />} />
          {/* 404 Catch-all route for dashboard */}
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Admin Routes - Separate admin interface */}
        <Route
          path="/admin/*"
          element={
            <AuthProtectedRoute>
              <AdminProtectedRoute requireAdmin>
                <AdminLayout />
              </AdminProtectedRoute>
            </AuthProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="sites" element={<AdminSites />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="workers" element={<AdminWorkers />} />
          <Route path="containers" element={<AdminContainers />} />
          <Route path="plans" element={<AdminPlans />} />
          <Route path="backups" element={<AdminBackups />} />
          <Route path="activities" element={<AdminActivities />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* Global 404 Catch-all route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
